const getResponseHeader = (headers, name) => {
    if (!headers) {
        return null;
    }
    const lower = name.toLowerCase();
    if (typeof headers.get === "function") {
        const value = headers.get(name) || headers.get(lower);
        if (value != null) {
            return value;
        }
    }
    return headers[name] ?? headers[lower] ?? null;
};

const parseLinkLastPage = (linkHeader) => {
    if (!linkHeader || typeof linkHeader !== "string") {
        return null;
    }

    const parts = linkHeader.split(",");
    for (const part of parts) {
        const match = part.match(/<([^>]+)>;\s*rel="last"/i);
        if (!match?.[1]) {
            continue;
        }

        try {
            const url = new URL(match[1], window.location.origin);
            const page = url.searchParams.get("page");
            if (page != null) {
                return parseInt(page, 10);
            }
        } catch {
            const pageMatch = match[1].match(/[?&]page=(\d+)/i);
            if (pageMatch?.[1]) {
                return parseInt(pageMatch[1], 10);
            }
        }
    }

    return null;
};

export const parsePaginatedListResponse = (response, options = {}) => {
    const data = response?.data;

    if (data && !Array.isArray(data) && Array.isArray(data.content)) {
        return data;
    }

    const content = Array.isArray(data) ? data : [];
    const pageSize = options.size || 20;
    const totalCountHeader = getResponseHeader(response?.headers, "X-Total-Count");
    const totalElements = totalCountHeader != null ? parseInt(totalCountHeader, 10) : content.length;

    let totalPages = 0;
    if (totalElements > 0) {
        const lastPage = parseLinkLastPage(getResponseHeader(response?.headers, "Link"));
        if (lastPage != null && !Number.isNaN(lastPage)) {
            totalPages = lastPage + 1;
        } else {
            totalPages = Math.ceil(totalElements / pageSize);
        }
    }

    return {
        content,
        totalElements,
        totalPages,
    };
};
